/**
 * Known ops-hub roles (friendly role names, i.e. the name segment of the role ARN -- see
 * types/Role.ts). For now access is coarse: CDHX-DevOps can do everything, CDHX-ReadOnly and
 * CDHX-Support are both read-only. As individual operations (docs/actions/*.md) get their own
 * approval/actor rules, extend this rather than hardcoding role name strings elsewhere.
 */
export const ROLE_NAMES = {
  devOps: 'CDHX-DevOps',
  readOnly: 'CDHX-ReadOnly',
  support: 'CDHX-Support',
} as const

export type RoleName = (typeof ROLE_NAMES)[keyof typeof ROLE_NAMES]
